import { render } from "./LinkSpot.vue?vue&type=template&id=4c46b4ef"
import script from "./LinkSpot.vue?vue&type=script&lang=js"
export * from "./LinkSpot.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__